import HorizontalGridContainer from 'components/containers/HorizontalGridContainer';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ButtonsContainer: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID
}) => (
    <HorizontalGridContainer
        className={`${className} ${styles.buttonsContainer}`}
        data-testid={testId}
    >
        {children}
    </HorizontalGridContainer>
);

export default ButtonsContainer;
